import React from "react";
import { RenderKilogramo } from "../../../../Utils/renderField/renderReadField";
import { TEXTO_PERIODO_SIN_ENVIOS } from "../helpers/tiposDiferenciaAcopio";

// Lo que cada almacén tenía, recibió y envió a producción en cada periodo
// cerrado. Las dos últimas filas son las que alimentan el comparativo, por eso
// van destacadas
const FILAS = [
    { etiqueta: "Inventario inicial lab", campo: "lab_inicial" },
    { etiqueta: "Inventario inicial liq", campo: "liq_inicial" },
    { etiqueta: "Ingresos lab", campo: "lab_ingresos" },
    { etiqueta: "Ingresos liq", campo: "liq_ingresos" },
    { etiqueta: "Inventario final lab", campo: "lab_final" },
    { etiqueta: "Inventario final liq", campo: "liq_final" },
    {
        etiqueta: "Enviado a producción lab",
        campo: "lab_enviado",
        destacada: true,
    },
    {
        etiqueta: "Enviado a producción liq",
        campo: "liq_enviado",
        destacada: true,
    },
];

// Los periodos sin envíos del producto padre se muestran igual, con una nota,
// porque siguen siendo parte del cierre
export const CierresAlmacenTable = ({ inventarios = [], periodosSinEnvios = [] }) => {
    // los almacenes de las columnas son los de todos los periodos juntos,
    // porque un periodo puede no tener movimiento en alguno
    const almacenes = React.useMemo(() => {
        const columnas = new Map();

        inventarios.forEach((periodo) => {
            periodo.almacenes.forEach((almacen) => {
                if (!columnas.has(almacen.clave)) {
                    columnas.set(almacen.clave, almacen);
                }
            });
        });

        return Array.from(columnas.values());
    }, [inventarios]);

    if (!inventarios.length) {
        return (
            <div className="text-center py-4">
                <h4>
                    No hay periodos de inventario de almacén cerrados en el
                    rango
                </h4>
            </div>
        );
    }

    const renderFila = (fila, periodo) => (
        <tr
            key={fila.campo}
            className={
                fila.destacada ? "comparativo-mensual__fila-enviado" : ""
            }
        >
            <td className="text-nowrap">{fila.etiqueta}</td>

            {almacenes.map((columna) => {
                const almacen = periodo.almacenes.find(
                    (item) => item.clave === columna.clave,
                );

                return (
                    <td
                        key={columna.clave}
                        className="text-right text-nowrap"
                    >
                        <RenderKilogramo
                            value={almacen ? almacen[fila.campo] || 0 : 0}
                            decimalScale={3}
                        />
                    </td>
                );
            })}

            <td className="text-right fw-bold text-nowrap cell-border-left">
                <RenderKilogramo
                    value={periodo.totales[fila.campo]}
                    decimalScale={3}
                />
            </td>
        </tr>
    );

    return (
        <div className="new-table-wrapper my-4 sticky-header sticky-first-column sticky-title-rows">
            <table className="table-striped-v2">
                <thead>
                    <tr>
                        <th>Almacén / Materia prima</th>

                        {almacenes.map((almacen) => (
                            <th key={almacen.clave}>
                                <div className="d-flex flex-column">
                                    <span className="text-nowrap">
                                        {almacen.nombre}
                                    </span>
                                    <span className="text-nowrap">
                                        {almacen.materia_prima}
                                    </span>
                                </div>
                            </th>
                        ))}

                        <th className="cell-border-left">Totales</th>
                    </tr>
                </thead>

                <tbody>
                    {inventarios.map((periodo) => (
                        <React.Fragment key={periodo.inventario_id}>
                            <tr className="bg-light sticky-title-row">
                                <td
                                    colSpan={almacenes.length + 2}
                                    className="cell-border-top cell-border-bottom"
                                >
                                    <span>
                                        <strong>{periodo.periodo}</strong>

                                        {periodosSinEnvios.includes(
                                            periodo.inventario_id,
                                        ) && (
                                            <span className="comparativo-mensual__nota-sin-envios">
                                                {TEXTO_PERIODO_SIN_ENVIOS}
                                            </span>
                                        )}
                                    </span>
                                </td>
                            </tr>

                            {FILAS.map((fila) => renderFila(fila, periodo))}
                        </React.Fragment>
                    ))}
                </tbody>
            </table>
        </div>
    );
};
